<template>
  <div class="datePicker">
    <span class="material-input-bar" />
    <label class="material-label">
      <slot />
    </label>
    <br v-if="$slots['default']" />
    <el-date-picker
      v-if="!disabled"
      v-model="currentValue"
      :type="type"
      :format="format"
      :name="name"
      :placeholder="fillPlaceHolder"
      :readonly="readonly"
      :required="required"
      @input="handleModelInput"
    />
    <span v-if="disabled" class="datePicker-disabled">{{ valueString }}</span>
  </div>
</template>

<script>
const dayjs = require('dayjs');
export default {
  props: {
    disabled: Boolean,
    format: {
      default: 'dd-MM-yyyy HH:mm',
      type: String
    },
    name: String,
    placeholder: {
      default: '',
      type: String
    },
    readonly: Boolean,
    required: {
      default: true,
      type: Boolean
    },
    value: [String, Number],
    type: {
      type: String,
      default: 'datetime'
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  computed: {
    fillPlaceHolder() {
      return this.currentValue ? '' : this.placeholder;
    },
    valueString() {
      let dayJsFormat = this.format || this.$store.getters.dateTimeFormat;
      dayJsFormat = dayJsFormat.replace(/(dd)/g, 'DD').replace(/(yyyy)/g, 'YYYY');
      const dt = new Date(this.currentValue).toString();
      return this.currentValue && dayjs(dt).format(dayJsFormat);
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  methods: {
    handleModelInput(event) {
      const value = event && Date.parse(event);
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>

<style scoped>
.datePicker-disabled {
  margin-top: 5px;
  display: block;
}
</style>

<style>
.material-label {
  color: #9e9e9e;
}
</style>
